import {
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Bolt,
  Box,
  Calendar,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleUser,
  Clipboard,
  Code2,
  Clock,
  Inbox,
  Copy,
  Download,
  Ellipsis,
  EllipsisVertical,
  Eye,
  EyeOff,
  File,
  FileText,
  Folder,
  Image,
  Info,
  LayoutGrid,
  List,
  Maximize2,
  Menu,
  MessageSquareText,
  Minimize2,
  Lock,
  Mail,
  MessageSquare,
  Moon,
  Music,
  MinusCircle,
  OctagonAlert,
  Package,
  Pencil,
  PieChart,
  Plug,
  Plus,
  RefreshCw,
  RotateCw,
  Search,
  Send,
  Settings,
  Star,
  Sun,
  Table,
  Ticket,
  Trash2,
  TriangleAlert,
  User,
  Users,
  Video,
  X,
  XCircle,
} from 'lucide-react'

export const iconMap = {
  alert: AlertTriangle,
  'alert-circle': CircleAlert,
  'alert-octagon': OctagonAlert,
  'alert-triangle': TriangleAlert,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  bolt: Bolt,
  box: Box,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  chat: MessageSquare,
  check: Check,
  'check-circle': CircleCheck,
  clipboard: Clipboard,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  clock: Clock,
  code: Code2,
  copy: Copy,
  docs: FileText,
  dollar: Package,
  download: Download,
  ellipsis: Ellipsis,
  'ellipsis-vertical': EllipsisVertical,
  envelope: Mail,
  eye: Eye,
  'eye-off': EyeOff,
  file: File,
  'file-text': FileText,
  folder: Folder,
  grid: LayoutGrid,
  group: Users,
  image: Image,
  inbox: Inbox,
  info: Info,
  list: List,
  lock: Lock,
  maximize: Maximize2,
  menu: Menu,
  'message-square-text': MessageSquareText,
  minimize: Minimize2,
  moon: Moon,
  mail: Mail,
  'minus-circle': MinusCircle,
  music: Music,
  package: Package,
  page: FileText,
  pencil: Pencil,
  'pie-chart': PieChart,
  plug: Plug,
  plus: Plus,
  refresh: RefreshCw,
  rotate: RotateCw,
  search: Search,
  send: Send,
  settings: Settings,
  star: Star,
  sun: Sun,
  table: Table,
  task: CircleCheck,
  ticket: Ticket,
  trash: Trash2,
  user: User,
  'user-circle': CircleUser,
  users: Users,
  video: Video,
  x: X,
  'x-circle': XCircle,
} as const

export type IconName = keyof typeof iconMap
